import angular from 'angular';
import RwCardComponent from './rw-card-component';

export default angular
   .module('rw-card', [])
   .component('rwCard', RwCardComponent);



// WEBPACK FOOTER //
// ./src/modules/utils/rw-card/rw-card-module.js